var _path, _path2, _path3, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0026 10.6693L12.0026 2.66927L10.6693 2.66927L10.6693 10.6693L12.0026 10.6693ZM13.3359 2.66927C13.3359 1.93289 12.739 1.33594 12.0026 1.33594L10.6693 1.33594C9.93289 1.33594 9.33594 1.93289 9.33594 2.66927L9.33594 10.6693C9.33594 11.4056 9.93289 12.0026 10.6693 12.0026L12.0026 12.0026C12.739 12.0026 13.3359 11.4056 13.3359 10.6693L13.3359 2.66927ZM6.66927 6.00261L6.66927 10.6693L5.33594 10.6693L5.33594 6.00261L6.66927 6.00261ZM6.66927 4.66927C7.40565 4.66927 8.00261 5.26623 8.00261 6.00261L8.00261 10.6693C8.00261 11.4057 7.40565 12.0026 6.66927 12.0026L5.33594 12.0026C4.59956 12.0026 4.0026 11.4057 4.0026 10.6693L4.0026 6.00261C4.0026 5.26623 4.59956 4.66927 5.33594 4.66927L6.66927 4.66927Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 13.3359L14.6693 13.3359L14.6693 14.6693L1.33594 14.6693L1.33594 13.3359Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 14.6641L1.33594 1.33073L2.66927 1.33073L2.66927 14.6641L1.33594 14.6641Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 4,
    height: 1.33333,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.33594,
    y: 4,
    width: 4,
    height: 1.33333,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsWhite);
export default __webpack_public_path__ + "static/media/stats-white.9c606976eb2c5850c7e250494d24c9dd.svg";
export { ForwardRef as ReactComponent };